var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('LiteratureContent',{attrs:{"clickedLiteratureurl":_vm.clickedLiteratureurl,"directorurl":_vm.directorurl},on:{"updatedData":_vm.updatedData,"deleted":_vm.deleted,"added":_vm.added}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }